export default __webpack_public_path__ + "static/media/5f20fa5f-87a6-4956-9884-6ebcf76531aa.5230a2e0.webp";